// // Product.jsx - FIXED VERSION
// import { useState, useEffect } from "react";
// import {
//   Container,
//   Table,
//   Button,
//   Modal,
//   Form,
//   Spinner,
//   Alert,
//   Badge,
//   Row,
//   Col,
//   Card
// } from "react-bootstrap";
// import { motion } from "framer-motion";
// import { 
//   FaEdit, 
//   FaTrash, 
//   FaBoxOpen, 
//   FaBuilding, 
//   FaRupeeSign,
//   FaFilter,
//   FaTimes,
//   FaSearch,
//   FaExclamationTriangle
// } from "react-icons/fa";
// import Header from "../../component/header/header";
// import Sidebar from "../../component/sidebar/sidebar";
// import "./product.css";

// const apiBase = process.env.REACT_APP_API_URL || "https://api.brandelsuperadmin.starlighttechlabsindia.com/api";

// const Product = () => {
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [show, setShow] = useState(false);
//   const [editData, setEditData] = useState(null);
  
//   // Filter states
//   const [selectedCompany, setSelectedCompany] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [companies, setCompanies] = useState([]);
//   const [showCompanyFilter, setShowCompanyFilter] = useState(false);

//   const token = localStorage.getItem("token");

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         setLoading(true);
//         console.log("Fetching products from:", `${apiBase}/admin/products-summary`);
        
//         const res = await fetch(
//           `${apiBase}/admin/products-summary`,
//           {
//             headers: { 
//               Authorization: `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             },
//           }
//         );
        
//         if (!res.ok) {
//           throw new Error(`HTTP error! status: ${res.status}`);
//         }
        
//         const data = await res.json();
//         console.log("API Response:", data);
        
//         // Extract products from the response
//         let productList = [];
//         let companyList = [];
        
//         if (data.companies && Array.isArray(data.companies)) {
//           data.companies.forEach(companyGroup => {
//             const companyName = companyGroup.companyName || "Unknown Company";
//             if (companyGroup.products && Array.isArray(companyGroup.products)) {
//               const productsWithCompany = companyGroup.products.map(product => ({
//                 ...product,
//                 company: product.company || companyName,
//                 stock: product.stock !== undefined ? product.stock : 0,
//                 price: product.price !== undefined ? product.price : 0,
//                 active: product.active !== undefined ? product.active : true
//               }));
//               productList = [...productList, ...productsWithCompany];
//             }
//             if (companyName && companyName !== "Unknown Company") {
//               companyList.push(companyName);
//             }
//           });
//         } else if (Array.isArray(data)) {
//           productList = data.map(product => ({
//             ...product,
//             company: product.company || "Unknown Company",
//             stock: product.stock !== undefined ? product.stock : 0,
//             price: product.price !== undefined ? product.price : 0,
//             active: product.active !== undefined ? product.active : true
//           }));
//         }
        
//         console.log("Extracted products:", productList);
//         console.log("Number of products:", productList.length);
        
//         // Set products
//         setProducts(productList);
//         setFilteredProducts(productList);
        
//         // Extract unique companies
//         const uniqueCompanies = [...new Set(
//           productList
//             .map(p => p.company || "Unknown Company")
//             .filter(c => c && c !== "Unknown Company")
//         )].sort();
        
//         if (companyList.length > 0) {
//           setCompanies([...new Set(companyList)].sort());
//         } else if (uniqueCompanies.length > 0) {
//           setCompanies(uniqueCompanies);
//         } else {
//           setCompanies(["All Products"]);
//         }
        
//         setError("");
//       } catch (err) {
//         console.error("Error fetching products:", err);
//         setError(err.message || "Failed to fetch products");
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     if (token) {
//       fetchProducts();
//     } else {
//       setError("No authentication token found");
//       setLoading(false);
//     }
//   }, [token]);

//   // Apply filters
//   useEffect(() => {
//     let result = [...products];
    
//     if (selectedCompany) {
//       result = result.filter(p => 
//         (p.company || "Unknown Company") === selectedCompany
//       );
//     }
    
//     if (searchTerm.trim()) {
//       const term = searchTerm.toLowerCase().trim();
//       result = result.filter(p => 
//         (p.name || "").toLowerCase().includes(term) ||
//         (p.category || "").toLowerCase().includes(term) ||
//         (p.company || "").toLowerCase().includes(term) ||
//         (p.description || "").toLowerCase().includes(term)
//       );
//     }
    
//     setFilteredProducts(result);
//   }, [products, selectedCompany, searchTerm]);

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this product?")) return;
    
//     try {
//       const res = await fetch(`${apiBase}/admin/product/${id}`, {
//         method: "DELETE",
//         headers: { Authorization: `Bearer ${token}` },
//       });
      
//       if (!res.ok) {
//         throw new Error(`Delete failed: ${res.status}`);
//       }
      
//       const updatedProducts = products.filter((p) => p._id !== id);
//       setProducts(updatedProducts);
//       setError("");
//     } catch (err) {
//       console.error("Error deleting product:", err);
//       setError("Failed to delete product: " + err.message);
//     }
//   };

//   const handleSave = async () => {
//     try {
//       const res = await fetch(
//         `${apiBase}/admin/product/${editData._id}`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(editData),
//         }
//       );
      
//       if (!res.ok) {
//         throw new Error(`Update failed: ${res.status}`);
//       }
      
//       const data = await res.json();
//       const updatedProduct = data.product || editData;
      
//       const updatedProducts = products.map((p) => 
//         p._id === updatedProduct._id ? updatedProduct : p
//       );
//       setProducts(updatedProducts);
//       setShow(false);
//       setError("");
//     } catch (err) {
//       console.error("Error updating product:", err);
//       setError("Failed to update product: " + err.message);
//     }
//   };

//   const handleInputChange = (field, value) => {
//     setEditData({ ...editData, [field]: value });
//   };

//   const clearFilters = () => {
//     setSelectedCompany("");
//     setSearchTerm("");
//   };

//   const getCompanyStats = (company) => {
//     const companyProducts = products.filter(p => 
//       (p.company || "Unknown Company") === company
//     );
//     return {
//       count: companyProducts.length,
//       totalStock: companyProducts.reduce((sum, p) => sum + (p.stock || 0), 0),
//       totalValue: companyProducts.reduce((sum, p) => sum + ((p.price || 0) * (p.stock || 0)), 0),
//     };
//   };

//   if (loading) {
//     return (
//       <>
//         <Header />
//         <div className="admin-layout">
//           <Sidebar />
//           <main className="admin-content">
//             <Container fluid>
//               <div className="text-center py-5">
//                 <Spinner animation="border" variant="primary" />
//                 <p className="mt-3">Loading products...</p>
//               </div>
//             </Container>
//           </main>
//         </div>
//       </>
//     );
//   }

//   console.log("Rendering products count:", filteredProducts.length);
//   console.log("Companies:", companies);

//   return (
//     <>
//       <Header />
//       <div className="admin-layout">
//         <Sidebar />
//         <main className="admin-content">
//           <Container fluid>
//             <Card className="shadow-sm">
//               <Card.Body>
//                 <motion.div
//                   initial={{ opacity: 0, y: 10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                 >
//                   <Row className="align-items-center mb-4">
//                     <Col>
//                       <h4 className="page-title mb-0">
//                         <FaBoxOpen className="me-2" /> Product Management
//                         <Badge bg="info" className="ms-3">
//                           {filteredProducts.length} Products
//                         </Badge>
//                         {selectedCompany && (
//                           <Badge bg="primary" className="ms-2">
//                             <FaBuilding className="me-1" />
//                             {selectedCompany}
//                           </Badge>
//                         )}
//                       </h4>
//                     </Col>
//                     <Col xs="auto">
//                       <Button
//                         variant="outline-secondary"
//                         size="sm"
//                         onClick={() => setShowCompanyFilter(!showCompanyFilter)}
//                         className="me-2"
//                       >
//                         <FaFilter className="me-1" />
//                         Filter
//                       </Button>
//                       {(selectedCompany || searchTerm) && (
//                         <Button
//                           variant="outline-danger"
//                           size="sm"
//                           onClick={clearFilters}
//                         >
//                           <FaTimes className="me-1" />
//                           Clear
//                         </Button>
//                       )}
//                     </Col>
//                   </Row>

//                   {/* Filter Section */}
//                   {showCompanyFilter && (
//                     <motion.div
//                       initial={{ opacity: 0, height: 0 }}
//                       animate={{ opacity: 1, height: "auto" }}
//                       className="filter-section mb-4 p-3 bg-light rounded"
//                     >
//                       <Row>
//                         <Col md={6}>
//                           <Form.Group>
//                             <Form.Label>
//                               <FaSearch className="me-1" /> Search Products
//                             </Form.Label>
//                             <Form.Control
//                               type="text"
//                               placeholder="Search by name, category, company..."
//                               value={searchTerm}
//                               onChange={(e) => setSearchTerm(e.target.value)}
//                             />
//                           </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                           <Form.Group>
//                             <Form.Label>
//                               <FaBuilding className="me-1" /> Filter by Company
//                             </Form.Label>
//                             <Form.Select
//                               value={selectedCompany}
//                               onChange={(e) => setSelectedCompany(e.target.value)}
//                             >
//                               <option value="">All Companies</option>
//                               {companies.map((company) => {
//                                 const stats = getCompanyStats(company);
//                                 return (
//                                   <option key={company} value={company}>
//                                     {company} ({stats.count} products)
//                                   </option>
//                                 );
//                               })}
//                             </Form.Select>
//                           </Form.Group>
//                         </Col>
//                       </Row>
                      
//                       {selectedCompany && (
//                         <Row className="mt-3">
//                           <Col>
//                             <div className="company-stats p-2 bg-white rounded border">
//                               <small className="text-muted">
//                                 <strong>{selectedCompany}</strong> - 
//                                 {getCompanyStats(selectedCompany).count} products, 
//                                 {getCompanyStats(selectedCompany).totalStock} units in stock, 
//                                 ₹{getCompanyStats(selectedCompany).totalValue.toFixed(2)} total value
//                               </small>
//                             </div>
//                           </Col>
//                         </Row>
//                       )}
//                     </motion.div>
//                   )}

//                   {error && (
//                     <Alert variant="danger" onClose={() => setError("")} dismissible>
//                       <FaExclamationTriangle className="me-2" />
//                       {error}
//                     </Alert>
//                   )}

//                   {/* Products Table */}
//                   <motion.div
//                     className="table-wrapper mt-3"
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                   >
//                     {filteredProducts.length === 0 ? (
//                       <Alert variant="info" className="text-center">
//                         <FaBoxOpen size={40} className="mb-2" />
//                         <p className="mb-0">
//                           {products.length === 0 
//                             ? "No products found. Products will appear here once added."
//                             : "No products match your filters. Try adjusting your search or filters."}
//                         </p>
//                         {products.length > 0 && (
//                           <Button variant="outline-primary" size="sm" className="mt-2" onClick={clearFilters}>
//                             Clear Filters
//                           </Button>
//                         )}
//                       </Alert>
//                     ) : (
//                       <div className="table-responsive">
//                         <Table hover className="product-table">
//                           <thead>
//                             <tr>
//                               <th>#</th>
//                               <th>Product Name</th>
//                               <th>Category</th>
//                               <th>Company</th>
//                               <th className="text-end">Price (₹)</th>
//                               <th className="text-end">Stock</th>
//                               <th>Status</th>
//                               <th className="text-center">Actions</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {filteredProducts.map((p, i) => {
//                               console.log(`Rendering product ${i+1}:`, p.name);
//                               return (
//                                 <motion.tr
//                                   key={p._id || i}
//                                   initial={{ opacity: 0 }}
//                                   animate={{ opacity: 1 }}
//                                   transition={{ delay: i * 0.03 }}
//                                 >
//                                   <td>{i + 1}</td>
//                                   <td>
//                                     <div className="fw-semibold">{p.name || "Unnamed Product"}</div>
//                                     {p.description && (
//                                       <small className="text-muted d-block">
//                                         {p.description.substring(0, 60)}
//                                         {p.description.length > 60 && "..."}
//                                       </small>
//                                     )}
//                                   </td>
//                                   <td>
//                                     <Badge bg="secondary">{p.category || "Uncategorized"}</Badge>
//                                   </td>
//                                   <td>
//                                     <FaBuilding className="me-1 text-secondary" />
//                                     {p.company || "N/A"}
//                                   </td>
//                                   <td className="text-end fw-bold">
//                                     <FaRupeeSign className="me-1" />
//                                     {Number(p.price || 0).toFixed(2)}
//                                   </td>
//                                   <td className="text-end">
//                                     <Badge bg={p.stock > 0 ? "success" : "danger"}>
//                                       {p.stock || 0} units
//                                     </Badge>
//                                   </td>
//                                   <td>
//                                     <Badge bg={p.active !== false ? "success" : "warning"}>
//                                       {p.active !== false ? "Active" : "Inactive"}
//                                     </Badge>
//                                   </td>
//                                   <td className="text-center">
//                                     <Button
//                                       size="sm"
//                                       variant="outline-primary"
//                                       className="me-2"
//                                       onClick={() => {
//                                         setEditData(p);
//                                         setShow(true);
//                                       }}
//                                     >
//                                       <FaEdit />
//                                     </Button>
//                                     <Button
//                                       size="sm"
//                                       variant="outline-danger"
//                                       onClick={() => handleDelete(p._id)}
//                                     >
//                                       <FaTrash />
//                                     </Button>
//                                   </td>
//                                 </motion.tr>
//                               );
//                             })}
//                           </tbody>
//                         </Table>
//                       </div>
//                     )}
//                   </motion.div>
//                 </motion.div>
//               </Card.Body>
//             </Card>
//           </Container>
//         </main>
//       </div>

//       {/* EDIT MODAL */}
//       <Modal show={show} onHide={() => setShow(false)} centered size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>
//             <FaEdit className="me-2" /> Edit Product
//           </Modal.Title>
//         </Modal.Header>
//         {editData && (
//           <Modal.Body>
//             <Form>
//               <Form.Group className="mb-3">
//                 <Form.Label>Product Name <span className="text-danger">*</span></Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={editData.name || ""}
//                   onChange={(e) => handleInputChange("name", e.target.value)}
//                   placeholder="Enter product name"
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Category</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={editData.category || ""}
//                   onChange={(e) => handleInputChange("category", e.target.value)}
//                   placeholder="Enter category"
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Company</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={editData.company || ""}
//                   onChange={(e) => handleInputChange("company", e.target.value)}
//                   placeholder="Enter company name"
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Price (₹) <span className="text-danger">*</span></Form.Label>
//                 <Form.Control
//                   type="number"
//                   step="0.01"
//                   value={editData.price || 0}
//                   onChange={(e) => handleInputChange("price", parseFloat(e.target.value))}
//                   placeholder="Enter price"
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Stock Quantity</Form.Label>
//                 <Form.Control
//                   type="number"
//                   value={editData.stock || 0}
//                   onChange={(e) => handleInputChange("stock", parseInt(e.target.value))}
//                   placeholder="Enter stock quantity"
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>Description</Form.Label>
//                 <Form.Control
//                   as="textarea"
//                   rows={3}
//                   value={editData.description || ""}
//                   onChange={(e) => handleInputChange("description", e.target.value)}
//                   placeholder="Enter product description"
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Check
//                   type="checkbox"
//                   label="Product Active"
//                   checked={editData.active !== false}
//                   onChange={(e) => handleInputChange("active", e.target.checked)}
//                 />
//               </Form.Group>
//             </Form>
//           </Modal.Body>
//         )}
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShow(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleSave}>
//             Save Changes
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default Product;

// Product.jsx - WITH IMAGE SUPPORT (FIXED)
import { useState, useEffect } from "react";
import {
  Container,
  Table,
  Button,
  Modal,
  Form,
  Spinner,
  Alert,
  Badge,
  Row,
  Col,
  Card,
  Image
} from "react-bootstrap";
import { motion } from "framer-motion";
import { 
  FaEdit, 
  FaTrash, 
  FaBoxOpen, 
  FaBuilding, 
  FaRupeeSign,
  FaFilter,
  FaTimes,
  FaSearch,
  FaExclamationTriangle,
  FaImage,
  FaUpload
} from "react-icons/fa";
import Header from "../../component/header/header";
import Sidebar from "../../component/sidebar/sidebar";
import "./product.css";

const apiBase = process.env.REACT_APP_API_URL || "https://api.brandelsuperadmin.starlighttechlabsindia.com/api";

const Product = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  
  // Filter states
  const [selectedCompany, setSelectedCompany] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [companies, setCompanies] = useState([]);
  const [showCompanyFilter, setShowCompanyFilter] = useState(false);

  const token = localStorage.getItem("token");

  // Helper function to get full image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    
    // If it's already a full URL
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath;
    }
    
    // If it starts with /images/, prepend the API base
    if (imagePath.startsWith('/images/')) {
      // Remove the leading slash and use the full path
      return `${apiBase}${imagePath}`;
    }
    
    // If it starts with /uploads/
    if (imagePath.startsWith('/uploads/')) {
      return `${apiBase}${imagePath}`;
    }
    
    // Default: assume it's a relative path
    return `${apiBase}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        console.log("Fetching products from:", `${apiBase}/admin/products-summary`);
        
        const res = await fetch(
          `${apiBase}/admin/products-summary`,
          {
            headers: { 
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
          }
        );
        
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        
        const data = await res.json();
        console.log("API Response:", data);
        
        // Extract products from the response
        let productList = [];
        let companyList = [];
        
        if (data.companies && Array.isArray(data.companies)) {
          data.companies.forEach(companyGroup => {
            const companyName = companyGroup.companyName || "Unknown Company";
            if (companyGroup.products && Array.isArray(companyGroup.products)) {
              const productsWithCompany = companyGroup.products.map(product => ({
                ...product,
                company: product.company || companyName,
                stock: product.stock !== undefined ? product.stock : 0,
                price: product.price !== undefined ? product.price : 0,
                active: product.isActive !== undefined ? product.isActive : true,
                // Keep the image path as is
                image: product.image || null
              }));
              productList = [...productList, ...productsWithCompany];
            }
            if (companyName && companyName !== "Unknown Company") {
              companyList.push(companyName);
            }
          });
        } else if (Array.isArray(data)) {
          productList = data.map(product => ({
            ...product,
            company: product.company || "Unknown Company",
            stock: product.stock !== undefined ? product.stock : 0,
            price: product.price !== undefined ? product.price : 0,
            active: product.isActive !== undefined ? product.isActive : true,
            image: product.image || null
          }));
        }
        
        console.log("Extracted products:", productList);
        console.log("Number of products:", productList.length);
        
        // Set products
        setProducts(productList);
        setFilteredProducts(productList);
        
        // Extract unique companies
        const uniqueCompanies = [...new Set(
          productList
            .map(p => p.company || "Unknown Company")
            .filter(c => c && c !== "Unknown Company")
        )].sort();
        
        if (companyList.length > 0) {
          setCompanies([...new Set(companyList)].sort());
        } else if (uniqueCompanies.length > 0) {
          setCompanies(uniqueCompanies);
        } else {
          setCompanies(["All Products"]);
        }
        
        setError("");
      } catch (err) {
        console.error("Error fetching products:", err);
        setError(err.message || "Failed to fetch products");
      } finally {
        setLoading(false);
      }
    };
    
    if (token) {
      fetchProducts();
    } else {
      setError("No authentication token found");
      setLoading(false);
    }
  }, [token]);

  // Apply filters
  useEffect(() => {
    let result = [...products];
    
    if (selectedCompany) {
      result = result.filter(p => 
        (p.company || "Unknown Company") === selectedCompany
      );
    }
    
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase().trim();
      result = result.filter(p => 
        (p.name || "").toLowerCase().includes(term) ||
        (p.category || "").toLowerCase().includes(term) ||
        (p.company || "").toLowerCase().includes(term) ||
        (p.description || "").toLowerCase().includes(term)
      );
    }
    
    setFilteredProducts(result);
  }, [products, selectedCompany, searchTerm]);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;
    
    try {
      const res = await fetch(`${apiBase}/admin/product/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      
      if (!res.ok) {
        throw new Error(`Delete failed: ${res.status}`);
      }
      
      const updatedProducts = products.filter((p) => p._id !== id);
      setProducts(updatedProducts);
      setError("");
    } catch (err) {
      console.error("Error deleting product:", err);
      setError("Failed to delete product: " + err.message);
    }
  };

  const handleSave = async () => {
    try {
      // If there's a new image file, upload it first
      let imagePath = editData.image;
      
      if (selectedImageFile) {
        const formData = new FormData();
        formData.append('image', selectedImageFile);
        
        const uploadRes = await fetch(`${apiBase}/upload`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`
          },
          body: formData
        });
        
        if (uploadRes.ok) {
          const uploadData = await uploadRes.json();
          imagePath = uploadData.imageUrl;
        } else {
          throw new Error('Failed to upload image');
        }
      }
      
      const updatedData = {
        ...editData,
        image: imagePath,
        isActive: editData.active
      };
      
      const res = await fetch(
        `${apiBase}/admin/product/${editData._id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedData),
        }
      );
      
      if (!res.ok) {
        throw new Error(`Update failed: ${res.status}`);
      }
      
      const data = await res.json();
      const updatedProduct = data.product || updatedData;
      
      const updatedProducts = products.map((p) => 
        p._id === updatedProduct._id ? updatedProduct : p
      );
      setProducts(updatedProducts);
      setShow(false);
      setError("");
      setSelectedImageFile(null);
      setImagePreview(null);
    } catch (err) {
      console.error("Error updating product:", err);
      setError("Failed to update product: " + err.message);
    }
  };

  const handleInputChange = (field, value) => {
    setEditData({ ...editData, [field]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const clearFilters = () => {
    setSelectedCompany("");
    setSearchTerm("");
  };

  const getCompanyStats = (company) => {
    const companyProducts = products.filter(p => 
      (p.company || "Unknown Company") === company
    );
    return {
      count: companyProducts.length,
      totalStock: companyProducts.reduce((sum, p) => sum + (p.stock || 0), 0),
      totalValue: companyProducts.reduce((sum, p) => sum + ((p.price || 0) * (p.stock || 0)), 0),
    };
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="admin-layout">
          <Sidebar />
          <main className="admin-content">
            <Container fluid>
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-3">Loading products...</p>
              </div>
            </Container>
          </main>
        </div>
      </>
    );
  }

  console.log("Rendering products count:", filteredProducts.length);

  return (
    <>
      <Header />
      <div className="admin-layout">
        <Sidebar />
        <main className="admin-content">
          <Container fluid>
            <Card className="shadow-sm">
              <Card.Body>
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                >
                  <Row className="align-items-center mb-4">
                    <Col>
                      <h4 className="page-title mb-0">
                        <FaBoxOpen className="me-2" /> Product Management
                        <Badge bg="info" className="ms-3">
                          {filteredProducts.length} Products
                        </Badge>
                        {selectedCompany && (
                          <Badge bg="primary" className="ms-2">
                            <FaBuilding className="me-1" />
                            {selectedCompany}
                          </Badge>
                        )}
                      </h4>
                    </Col>
                    <Col xs="auto">
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => setShowCompanyFilter(!showCompanyFilter)}
                        className="me-2"
                      >
                        <FaFilter className="me-1" />
                        Filter
                      </Button>
                      {(selectedCompany || searchTerm) && (
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={clearFilters}
                        >
                          <FaTimes className="me-1" />
                          Clear
                        </Button>
                      )}
                    </Col>
                  </Row>

                  {/* Filter Section */}
                  {showCompanyFilter && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      className="filter-section mb-4 p-3 bg-light rounded"
                    >
                      <Row>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              <FaSearch className="me-1" /> Search Products
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Search by name, category, company..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              <FaBuilding className="me-1" /> Filter by Company
                            </Form.Label>
                            <Form.Select
                              value={selectedCompany}
                              onChange={(e) => setSelectedCompany(e.target.value)}
                            >
                              <option value="">All Companies</option>
                              {companies.map((company) => {
                                const stats = getCompanyStats(company);
                                return (
                                  <option key={company} value={company}>
                                    {company} ({stats.count} products)
                                  </option>
                                );
                              })}
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>
                      
                      {selectedCompany && (
                        <Row className="mt-3">
                          <Col>
                            <div className="company-stats p-2 bg-white rounded border">
                              <small className="text-muted">
                                <strong>{selectedCompany}</strong> - 
                                {getCompanyStats(selectedCompany).count} products, 
                                {getCompanyStats(selectedCompany).totalStock} units in stock, 
                                ₹{getCompanyStats(selectedCompany).totalValue.toFixed(2)} total value
                              </small>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </motion.div>
                  )}

                  {error && (
                    <Alert variant="danger" onClose={() => setError("")} dismissible>
                      <FaExclamationTriangle className="me-2" />
                      {error}
                    </Alert>
                  )}

                  {/* Products Table */}
                  <motion.div
                    className="table-wrapper mt-3"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                  >
                    {filteredProducts.length === 0 ? (
                      <Alert variant="info" className="text-center">
                        <FaBoxOpen size={40} className="mb-2" />
                        <p className="mb-0">
                          {products.length === 0 
                            ? "No products found. Products will appear here once added."
                            : "No products match your filters. Try adjusting your search or filters."}
                        </p>
                        {products.length > 0 && (
                          <Button variant="outline-primary" size="sm" className="mt-2" onClick={clearFilters}>
                            Clear Filters
                          </Button>
                        )}
                      </Alert>
                    ) : (
                      <div className="table-responsive">
                        <Table hover className="product-table">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Image</th>
                              <th>Product Name</th>
                              <th>Category</th>
                              <th>Company</th>
                              <th className="text-end">Price (₹)</th>
                              <th className="text-end">Stock</th>
                              <th>Status</th>
                              <th className="text-center">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredProducts.map((p, i) => {
                              const imageUrl = getImageUrl(p.image);
                              console.log(`Product ${p.name} image URL:`, imageUrl);
                              
                              return (
                                <motion.tr
                                  key={p._id || i}
                                  initial={{ opacity: 0 }}
                                  animate={{ opacity: 1 }}
                                  transition={{ delay: i * 0.03 }}
                                >
                                  <td>{i + 1}</td>
                                  <td>
                                    {imageUrl ? (
                                      <Image 
                                        src={imageUrl} 
                                        alt={p.name || "Product"}
                                        className="product-thumbnail"
                                        onError={(e) => {
                                          console.error(`Failed to load image: ${imageUrl}`);
                                          e.target.style.display = 'none';
                                          // Show fallback icon
                                          const parent = e.target.parentElement;
                                          const fallback = document.createElement('div');
                                          fallback.className = 'image-fallback';
                                          fallback.innerHTML = '<FaImage className="text-muted" size={30} />';
                                          parent.appendChild(fallback);
                                        }}
                                      />
                                    ) : (
                                      <div className="image-fallback">
                                        <FaImage className="text-muted" size={30} />
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    <div className="fw-semibold">{p.name || "Unnamed Product"}</div>
                                    {p.description && (
                                      <small className="text-muted d-block">
                                        {p.description.substring(0, 60)}
                                        {p.description.length > 60 && "..."}
                                      </small>
                                    )}
                                  </td>
                                  <td>
                                    <Badge bg="secondary">{p.category || "Uncategorized"}</Badge>
                                  </td>
                                  <td>
                                    <FaBuilding className="me-1 text-secondary" />
                                    {p.company || "N/A"}
                                  </td>
                                  <td className="text-end fw-bold">
                                    <FaRupeeSign className="me-1" />
                                    {Number(p.price || 0).toFixed(2)}
                                  </td>
                                  <td className="text-end">
                                    <Badge bg={p.stock > 0 ? "success" : "danger"}>
                                      {p.stock || 0} units
                                    </Badge>
                                  </td>
                                  <td>
                                    <Badge bg={p.active !== false ? "success" : "warning"}>
                                      {p.active !== false ? "Active" : "Inactive"}
                                    </Badge>
                                  </td>
                                  <td className="text-center">
                                    <Button
                                      size="sm"
                                      variant="outline-primary"
                                      className="me-2"
                                      onClick={() => {
                                        setEditData(p);
                                        setImagePreview(getImageUrl(p.image));
                                        setSelectedImageFile(null);
                                        setShow(true);
                                      }}
                                    >
                                      <FaEdit />
                                    </Button>
                                    <Button
                                      size="sm"
                                      variant="outline-danger"
                                      onClick={() => handleDelete(p._id)}
                                    >
                                      <FaTrash />
                                    </Button>
                                  </td>
                                </motion.tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </motion.div>
                </motion.div>
              </Card.Body>
            </Card>
          </Container>
        </main>
      </div>

      {/* EDIT MODAL */}
      <Modal show={show} onHide={() => {
        setShow(false);
        setSelectedImageFile(null);
        setImagePreview(null);
      }} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <FaEdit className="me-2" /> Edit Product
          </Modal.Title>
        </Modal.Header>
        {editData && (
          <Modal.Body>
            <Form>
              <Row>
                <Col md={8}>
                  <Form.Group className="mb-3">
                    <Form.Label>Product Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={editData.name || ""}
                      onChange={(e) => handleInputChange("name", e.target.value)}
                      placeholder="Enter product name"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Category</Form.Label>
                    <Form.Control
                      type="text"
                      value={editData.category || ""}
                      onChange={(e) => handleInputChange("category", e.target.value)}
                      placeholder="Enter category"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Company</Form.Label>
                    <Form.Control
                      type="text"
                      value={editData.company || ""}
                      onChange={(e) => handleInputChange("company", e.target.value)}
                      placeholder="Enter company name"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Price (₹) <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      value={editData.price || 0}
                      onChange={(e) => handleInputChange("price", parseFloat(e.target.value))}
                      placeholder="Enter price"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Stock Quantity</Form.Label>
                    <Form.Control
                      type="number"
                      value={editData.stock || 0}
                      onChange={(e) => handleInputChange("stock", parseInt(e.target.value))}
                      placeholder="Enter stock quantity"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>SKU</Form.Label>
                    <Form.Control
                      type="text"
                      value={editData.sku || ""}
                      onChange={(e) => handleInputChange("sku", e.target.value)}
                      placeholder="Enter SKU"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={editData.description || ""}
                      onChange={(e) => handleInputChange("description", e.target.value)}
                      placeholder="Enter product description"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Product Image</Form.Label>
                    <div className="image-upload-container">
                      {imagePreview ? (
                        <div className="image-preview">
                          <Image 
                            src={imagePreview} 
                            alt="Product preview"
                            className="preview-image"
                            fluid
                          />
                          <Button
                            variant="outline-danger"
                            size="sm"
                            className="remove-image-btn"
                            onClick={() => {
                              setImagePreview(null);
                              setSelectedImageFile(null);
                              handleInputChange("image", null);
                            }}
                          >
                            <FaTimes />
                          </Button>
                        </div>
                      ) : (
                        <div className="image-placeholder">
                          <FaImage size={50} className="text-muted" />
                          <p className="text-muted small mt-2">No image uploaded</p>
                        </div>
                      )}
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="image-input"
                      />
                      <div className="image-input-label">
                        <FaUpload className="me-2" />
                        {imagePreview ? 'Change Image' : 'Upload Image'}
                      </div>
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Product Active"
                      checked={editData.active !== false}
                      onChange={(e) => handleInputChange("active", e.target.checked)}
                    />
                  </Form.Group>

                  {editData.sku && (
                    <div className="mt-3 p-2 bg-light rounded">
                      <small className="text-muted">
                        <strong>SKU:</strong> {editData.sku}
                      </small>
                    </div>
                  )}
                </Col>
              </Row>
            </Form>
          </Modal.Body>
        )}
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShow(false);
            setSelectedImageFile(null);
            setImagePreview(null);
          }}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Product;